module.exports = __webpack_public_path__ + "static/media/10f81a81-a41e-4acb-9a19-056cc1cf466b.acac8d73.png";